(() => {
  const initializeModule = (module) => {
    if (module.dataset.completeTheSetInitialized === 'true') return;

    const select = module.querySelector('[data-complete-the-set-select]');
    const price = module.querySelector('[data-complete-the-set-price]');
    const comparePrice = module.querySelector('[data-complete-the-set-compare-price]');
    const addButton = module.querySelector('[data-complete-the-set-add]');

    if (!price || !comparePrice || !addButton) return;

    let selectedVariantId = module.dataset.selectedVariantId;
    let selectedVariantAvailable = module.dataset.selectedVariantAvailable === 'true';

    const updateFromOption = (option) => {
      if (!option) return;

      selectedVariantId = option.value;
      selectedVariantAvailable = option.dataset.available === 'true';
      price.textContent = option.dataset.price || '';

      const formattedComparePrice = option.dataset.comparePrice || '';
      comparePrice.textContent = formattedComparePrice;
      comparePrice.hidden = !formattedComparePrice;

      addButton.disabled = !selectedVariantAvailable;
      addButton.textContent = selectedVariantAvailable ? 'ADD TO BAG' : 'SOLD OUT';
    };

    if (select) {
      updateFromOption(select.options[select.selectedIndex]);
      select.addEventListener('change', () => {
        updateFromOption(select.options[select.selectedIndex]);
      });
    }

    addButton.addEventListener('click', () => {
      if (!selectedVariantAvailable || !selectedVariantId || typeof cart === 'undefined') return;
      cart.add_to_cart('slideout', selectedVariantId, 1);
    });

    module.dataset.completeTheSetInitialized = 'true';
  };

  document.querySelectorAll('[data-complete-the-set]').forEach(initializeModule);
})();
